import { pick } from 'lodash'

import { toLines } from '../../../../common/utils'

const dietSimpleDetailsFormInitialValues = diet => ({
  ...pick(diet, [
    'description',
    'position',
    'isExcludedFromSearch',
    'isAvailableForDishCategorization',
    'isPopular',
  ]),
  synonyms: toLines(diet.synonyms),
})

export default dietSimpleDetailsFormInitialValues
